import { graphql } from 'react-relay';

export const userGeoInfoQuery = graphql`
    query userGeoInfoQuery {
        viewer {
            regionalInfo {
                countryCode
                zipCode
            }
        }
    }
`;
